import axiosInstance from '../axiosInstance';

const getAllRequestsAPI = async (params) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request` + params;
    return await axiosInstance.get(url);
};

const getRequestByIdAPI = async (requestId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}`;
    return await axiosInstance.get(url);
};

const createRequestInformationAPI = async (requestInformation) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/information`;
    return await axiosInstance.post(url, requestInformation);
};

const updateRequestInformationAPI = async (requestId, requestInformation) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/information/${requestId}`;
    return await axiosInstance.put(url, requestInformation);
};

const addUpdateAccountingInformationAPI = async (requestId, body) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/accounting-information/${requestId}`;
    return await axiosInstance.put(url, body);
};

const addUpdatePaymentInformationAPI = async (requestId, body) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/payment-information/${requestId}`;
    return await axiosInstance.put(url, body);
};

const getAllRequestItemsAPI = async (requestId, params) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/line-entry` + params;
    return await axiosInstance.get(url);
};
const addRequestItemAPI = async (requestId, LineEntries) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/add-line-entry`;
    return await axiosInstance.post(url, LineEntries);
};
const updateRequestItemAPI = async (reqId, lineId, LineEntries) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${reqId}/update-line-entry/${lineId}`;
    return await axiosInstance.put(url, LineEntries);
};

const uploadRequestItemAPI = async (requestId, LineEntries) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/upload-line-entry`;
    return await axiosInstance.post(url, LineEntries, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const deleteRequestItemAPI = async (requestId, items) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/line-entry`;
    return await axiosInstance.post(url, items);
};

const deleteAllRequestItemOfRequestAPI = async (requestId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/line-entry`;
    return await axiosInstance.delete(url);
};

const attachSupportingDocumentAPI = async (requestId, file, type) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/attachment/${type}`;
    return await axiosInstance.post(url, file, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
const getAttachmentsOfRequestAPI = async (requestId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/attachments`;
    return await axiosInstance.get(url);
};

const downloadAttachmentAPI = async (attachmentId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/attachment/${attachmentId}`;
    return await axiosInstance.get(url, {
        responseType: 'blob',
    });
};
const deleteAttachmentAPI = async (attachmentId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/attachment/${attachmentId}`;
    return await axiosInstance.delete(url);
};
const downloadLineEntryTemplateAPI = async (type) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/line-entry-template/${type}`;
    return await axiosInstance.get(url, {
        responseType: 'blob',
    });
};

const getRequestReportAPI = async (params) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/report` + params;
    return await axiosInstance.get(url);
};
const downloadRequestReportAPI = async (params) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/report/download` + params;
    return await axiosInstance.get(url, {
        responseType: 'blob',
    });
};
const getRequestFiltersAPI = async () => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/filter-options`;
    return await axiosInstance.get(url);
};
const submitRequestAPI = async (requestId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/submit`;
    return await axiosInstance.post(url);
};
const reProcessRequestAPI = async (requestId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/re-process`;
    return await axiosInstance.post(url);
};
const reverseRequestAPI = async (requestId, reason) => {
    console.log(requestId, reason);
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/reverse`;
    return await axiosInstance.post(url, { reversalReason: reason });
};
const forceReverseRequestAPI = async (requestId, reason, sapReversalCode) => {
    console.log(requestId, reason);
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/reverse-force`;
    return await axiosInstance.post(url, { reversalReason: reason, sapReversalCode: sapReversalCode });
};
const getRequestKPIAPI = async () => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/kpi`;
    return await axiosInstance.get(url);
};
const getAllowedPaymentInformationFieldsAPI = async (companyCode) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/payment-information/get-fields/${companyCode}`;
    return await axiosInstance.get(url);
};
const checkIfApprovedVendorAPI = async (data) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/information/is-vendor-approved/${data.vendor}/company-code/${data.companyCode}`;
    return await axiosInstance.get(url);
};
const getDefaultValuesOfPaymentInformationAPI = async (companyCode) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/payment-information/get-default-values/${companyCode}`;
    return await axiosInstance.get(url);
};
const cloneRequestAPI = async (requestId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/clone`;
    return await axiosInstance.post(url);
};
const updateTaxInformationAPI = async (requestId, body) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/tax-information`;
    return await axiosInstance.put(url, body);
};
const downloadExcelType1API = async () => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/bulk-template/1`;
    return await axiosInstance.get(url, {
        responseType: 'blob',
    });
};

const uploadExcelType1API = async (formData) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/bulk`;
    return await axiosInstance.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
const downloadExcelType2API = async () => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/bulk-template/2`;
    return await axiosInstance.get(url, {
        responseType: 'blob',
    });
};

const uploadExcelType2API = async (formData) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/bulk-request`;
    return await axiosInstance.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const syncRequestAPI = async (requestId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/sync`;
    return await axiosInstance.post(url);
};
const checkLineItemsBalance = async (requestId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/check-balance`;
    return await axiosInstance.get(url);
};
const submitProofAPI = async (requestId, body) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/proof-of-payment`;
    return await axiosInstance.post(url, body);
};

const submitProofWithoutTaskAPI = async (requestId, body) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/proof-of-payment-no-task`;
    return await axiosInstance.post(url, body);
};
const requestProofOfPaymentAPI = async (requestId, body) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/request-proof-of-payment`;
    return await axiosInstance.post(url, body);
};
const deleteRequestAPI = async (requestId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}`;
    return await axiosInstance.delete(url);
};

export default {
    getAllRequestsAPI,
    getRequestByIdAPI,
    createRequestInformationAPI,
    updateRequestInformationAPI,
    addUpdateAccountingInformationAPI,
    addUpdatePaymentInformationAPI,
    getAllRequestItemsAPI,
    addRequestItemAPI,
    updateRequestItemAPI,
    uploadRequestItemAPI,
    deleteRequestItemAPI,
    deleteAllRequestItemOfRequestAPI,
    attachSupportingDocumentAPI,
    getAttachmentsOfRequestAPI,
    downloadAttachmentAPI,
    deleteAttachmentAPI,
    downloadLineEntryTemplateAPI,
    getRequestReportAPI,
    downloadRequestReportAPI,
    getRequestFiltersAPI,
    submitRequestAPI,
    reProcessRequestAPI,
    reverseRequestAPI,
    forceReverseRequestAPI,
    getRequestKPIAPI,
    getAllowedPaymentInformationFieldsAPI,
    checkIfApprovedVendorAPI,
    getDefaultValuesOfPaymentInformationAPI,
    cloneRequestAPI,
    updateTaxInformationAPI,
    downloadExcelType1API,
    uploadExcelType1API,
    downloadExcelType2API,
    uploadExcelType2API,
    syncRequestAPI,
    checkLineItemsBalance,
    submitProofAPI,
    submitProofWithoutTaskAPI,
    requestProofOfPaymentAPI,
    deleteRequestAPI,
};
